import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { formatDateTime } from '../../utils/formatters';
import { DesktopForm } from '../../components/DesktopForm';
import { Success } from '../../components/Success/desktop';
import { Fail } from '../../components/Fail/desktop';
import { Modal } from '../../components/Modal/desktop';
import { getDateTimestamp } from '../../utils/getDateTimestamp';
import { PRIVACY_POLICY_URL } from '../../constants/links';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EProgressSteps;
(function (EProgressSteps) {
  EProgressSteps[EProgressSteps["SubmitStep"] = 0] = "SubmitStep";
  EProgressSteps[EProgressSteps["Success"] = 1] = "Success";
  EProgressSteps[EProgressSteps["Fail"] = 2] = "Fail";
})(EProgressSteps || (EProgressSteps = {}));
export function FlatViewOrderSinglePageDesktop(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    onSuccess = _ref.onSuccess,
    onFail = _ref.onFail,
    onSubmit = _ref.onSubmit,
    disabledDays = _ref.disabledDays,
    availableDates = _ref.availableDates,
    newbuildingName = _ref.newbuildingName,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    nextDate = _ref.nextDate,
    nextNextDate = _ref.nextNextDate,
    _ref$privacyPolicyUrl = _ref.privacyPolicyUrl,
    privacyPolicyUrl = _ref$privacyPolicyUrl === void 0 ? PRIVACY_POLICY_URL : _ref$privacyPolicyUrl;
  var _React$useState = React.useState(EProgressSteps.SubmitStep),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    step = _React$useState2[0],
    setStep = _React$useState2[1];
  var _React$useState3 = React.useState(new Date(0)),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    dateTime = _React$useState4[0],
    setDateTime = _React$useState4[1];
  var close = function close() {
    /*istanbul ignore next*/
    if (onClose) {
      onClose();
    }
    setDateTime(new Date(0));
    setStep(EProgressSteps.SubmitStep);
  };
  var subscribe = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var name, phone, dateTime, dateTimestamp, isSuccess;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            name = _ref2.name, phone = _ref2.phone, dateTime = _ref2.dateTime;
            setDateTime(dateTime);
            dateTimestamp = getDateTimestamp(dateTime);
            _context.prev = 3;
            _context.next = 6;
            return onSubmit(_objectSpread({
              phone: phone,
              name: name
            }, dateTimestamp));
          case 6:
            isSuccess = _context.sent;
            if (isSuccess) {
              setStep(EProgressSteps.Success);

              /*istanbul ignore next*/
              if (onSuccess) {
                onSuccess(_objectSpread({
                  phone: phone,
                  name: name
                }, dateTimestamp));
              }
            } else {
              setStep(EProgressSteps.Fail);

              /*istanbul ignore next*/
              if (onFail) {
                onFail(_objectSpread({
                  phone: phone,
                  name: name
                }, dateTimestamp));
              }
            }
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            setStep(EProgressSteps.Fail);

            /*istanbul ignore next*/
            if (onFail) {
              onFail(_objectSpread({
                phone: phone,
                name: name
              }, dateTimestamp));
            }
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10]]);
    }));
    return function subscribe(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_jsxs(Modal, {
    open: isOpen,
    onClose: close,
    children: [step === EProgressSteps.SubmitStep && /*#__PURE__*/_jsx(DesktopForm, {
      newbuildingName: newbuildingName,
      minDate: minDate,
      maxDate: maxDate,
      disabledDays: disabledDays,
      availableDates: availableDates,
      nextDate: nextDate,
      nextNextDate: nextNextDate,
      privacyPolicyUrl: privacyPolicyUrl,
      onSubmit: subscribe
    }), step === EProgressSteps.Success && /*#__PURE__*/_jsx(Success, {
      newbuildingName: newbuildingName,
      dateTime: formatDateTime(dateTime),
      onClick: close
    }), step === EProgressSteps.Fail && /*#__PURE__*/_jsx(Fail, {
      onClick: close
    })]
  });
}